import request from "@/utils/request";
// 查询商品分类列表
const getClassifyList = (params) =>
  request.post("/laiHi/web/shopping/queryGoodsTypeList", params);
// 添加修改商品分类
const setClassify = (params) =>
  request.post("/laiHi/web/shopping/addModifyGoodsType", params);
// 修改分类状态
const editClassifyStatus = (params) =>
  request.post("/laiHi/web/shopping/modifyGoodsTypeStatus", params);
// 推荐/取消显示商品分类
const editClassifyShow = (params) =>
  request.post("/laiHi/web/shopping/recommendShowGoodsType", params);
// 删除商品分类
const deleteClassify = (params) =>
  request.post("/laiHi/web/shopping/deleteGoodsType", params);

// 商品列表
const getGoodsList = (params) =>
  request.post("/laiHi/web/shopping/goodsList", params);
// 添加修改商品
const setGoods = (params) =>
  request.post("/laiHi/web/shopping/addModifyGoods", params);
// 删除商品
const deleteGoods = (params) =>
  request.post("/laiHi/web/shopping/deleteGoods", params);
// 商品详情信息
const getGoodsDetails = (params) =>
  request.post("/laiHi/web/shopping/goodsDetailInfo", params);
// 修改商品状态
const editGoodsStatus = (params) =>
  request.post("/laiHi/web/shopping/modifyGoodsIsListed", params);

// 订单列表
const getOrderList = (params) =>
  request.post("/laiHi/web/shopping/goodsOrderList", params);
// 订单详情
const getOrderDetails = (params) =>
  request.post("/laiHi/web/shopping/goodsOrderDetail", params);
// 订单退款
const refundOrder = (params) =>
  request.post("/laiHi/web/shopping/goodsOrderRefund", params);
// 删除订单
const deleteOrder = (params) =>
  request.post("/laiHi/web/shopping/deletedGoodsOrder", params);

// 售后管理列表
const getAfterSalesList = (params) =>
  request.post("/laiHi/web/shopping/goodsOrderRefundList", params);
// 售后管理-同意
const agreeAfter = (params) =>
  request.post("/laiHi/web/shopping/agreeGoodsOrderRefund", params);
// 售后管理-拒绝
const refuseAfter = (params) =>
  request.post("/laiHi/web/shopping/refuseGoodsOrderRefund", params);

// 获取快递公司信息
const getExpressList = () => request.post("/laiHi/common/queryExpressCompany");
// 订单发货
const getDelivery = (params) =>
  request.post("/laiHi/web/shopping/deliveryGoodsOrder", params);
// 查看物流
const checkExpress = (expressNo, expressCode) =>
  request.get(`/laiHi/common/getExpressInfo/${expressNo}/${expressCode}`);
export {
  getClassifyList,
  setClassify,
  editClassifyStatus,
  editClassifyShow,
  deleteClassify,
  getGoodsList,
  setGoods,
  deleteGoods,
  getGoodsDetails,
  editGoodsStatus,
  getOrderList,
  getOrderDetails,
  getAfterSalesList,
  agreeAfter,
  refuseAfter,
  refundOrder,
  deleteOrder,
  getExpressList,
  getDelivery,
  checkExpress,
};
